import { render } from "./EditPayment.vue?vue&type=template&id=79c9ddae&scoped=true"
import script from "./EditPayment.vue?vue&type=script&lang=js"
export * from "./EditPayment.vue?vue&type=script&lang=js"

import "./EditPayment.vue?vue&type=style&index=0&id=79c9ddae&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c9ddae"]])

export default __exports__